module.exports = __webpack_public_path__ + "img/search.f703fe86.svg";